import { useContext } from 'react';

// components
import { BUTTON_TYPES, Button } from 'components/Button/Button';
import { Image } from 'components/image/image';
import { InnerHtml } from 'components/InnerHtml/inner-html';

// utils
import { InteractiveDescriptionContext } from '../context';
import { truncateAtWordBoundary } from 'utils/truncate';
import { renderLinks } from 'utils/links';
import { useTracking as useTracking2 } from 'utils/tracking/track';
import { trackInteractiveDescriptionInfoClick } from 'components/ContentElements/interactive-description/interactive-description';

export function DescriptionActive() {
  const { contentWhenClicked, isChild, infoText, handleCloseDescription } = useContext(
    InteractiveDescriptionContext,
  );
  const { headline, subline, picture, pictureAlt, description, text, links, pictureObject } =
    contentWhenClicked ?? {};

  const { trackClick } = useTracking2();

  return (
    <div className="interactive-description__content large-6">
      {headline && (
        <InnerHtml
          as={isChild ? 'h5' : 'h4'}
          className={isChild ? 'h4' : undefined}
          content={truncateAtWordBoundary(headline, 75)}
        />
      )}
      <div className="c-tiles__column">
        {picture && (
          <Image
            className="c-tiles__image"
            src={picture}
            alt={pictureAlt}
            title={description || pictureAlt || ''}
            data={pictureObject}
            lazy={false}
          >
            <Button
              symbol={`icon icon--white web20-icon web20-icon-close`}
              type={BUTTON_TYPES.PLAIN}
              onClick={handleCloseDescription}
            />
          </Image>
        )}
        <div className="c-tiles__content">
          {!picture && (
            <Button
              symbol="icon icon--black web20-icon web20-icon-close"
              type={BUTTON_TYPES.PLAIN}
              onClick={handleCloseDescription}
            />
          )}
          {subline && (
            <InnerHtml
              as={isChild ? 'h5' : 'h4'}
              className={isChild ? 'h4' : undefined}
              content={subline}
            />
          )}
          <InnerHtml
            as="p"
            content={text}
            className={text && !picture ? 'tileWithoutImage' : undefined}
          />
          {renderLinks(links)}
        </div>
      </div>
      {infoText && (
        <p className="interactive-description__info">
          <button tabIndex={0} onClick={trackInteractiveDescriptionInfoClick(trackClick)}>
            <i className="icon web20-icon web20-icon-info-circle-full" />
          </button>
          <InnerHtml as="span" content={truncateAtWordBoundary(infoText, 50)} />
        </p>
      )}
    </div>
  );
}
